import axios from "axios";
import { desEncriptar, encriptar } from "../../utilidades/encriptacion"
import Swal from "sweetalert2";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION
const urlApi = process.env.REACT_APP_API_KEY
const urlAudit = process.env.REACT_APP_API_AUDITORIAS

export const peticionLogin = async (email, password, navigate) => {

    const credenciales = {
        email,
        password
    }
    await axios.post(`${urlApi}/auth/login`, credenciales).then((res) => {
        if(res.data.token) {
            // sessionStorage.setItem('auth', encriptar("true", key));
            sessionStorage.setItem('token', res.data.token);
            sessionStorage.setItem('dataClient', encriptar(JSON.stringify(res.data),key));
            Swal.fire({
                title: "SESIÓN INICIADA",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            if(res.data.addHealth.ADD_HEALTH) {
                navigate("/bienestar")
            } else {
                const auth = encriptar("true", key);
                sessionStorage.setItem("auth", auth);
                window.location.href = '/administracion';
            }
        }
    }).catch((error) => {
        Swal.fire({
            title: "ERROR AL INICIAR SESION",
            text: error.response.data.message,
            icon: "error",
            timer: 3000,
            showConfirmButton: false,
        });
    })

}

export const sendEmail = async (email) => {
    try {
        const response = await axios.post(`${urlApi}/auth/sendPasswordByEmail`, { email });
        return response.data;
    } catch (e) {
        console.log("error", e);
        throw new Error(e);
    }
}
